var map = {
	"./Invitation/Invitation.vue": 26458,
	"./account/account.vue": 29118,
	"./account/accountAdd.vue": 42391,
	"./addedTax/addedTax.vue": 50058,
	"./allCertificate/allCertificate.vue": 45227,
	"./appeal/appeal.vue": 92351,
	"./appeal/appealDetail.vue": 18112,
	"./apply/apply.vue": 80083,
	"./article/article.vue": 72897,
	"./article/articleAdd.vue": 13305,
	"./askari/askari.vue": 21350,
	"./askari/askariDetail.vue": 20848,
	"./authorization/authorization.vue": 55870,
	"./authorization/authorizationAdd.vue": 57628,
	"./balance/balance.vue": 55061,
	"./balance/balanceAdd.vue": 95909,
	"./certificate/certificate.vue": 4935,
	"./certificate/certificateDetail.vue": 76496,
	"./channel/channel.vue": 88320,
	"./classify/classify.vue": 2906,
	"./classify/classifyAdd.vue": 65535,
	"./companyFinance/companyFinance.vue": 29428,
	"./complaint/complaint.vue": 66992,
	"./complaint/complaintAdd.vue": 10865,
	"./config/config.vue": 63888,
	"./customer/customer.vue": 63713,
	"./customized/customized.vue": 72507,
	"./customizedDeatil/customizedDetail.vue": 84417,
	"./dashboard/dashboard.vue": 16379,
	"./dealings/dealings.vue": 56083,
	"./default/default.vue": 32597,
	"./default/defaultDetail.vue": 27459,
	"./department/department.vue": 65540,
	"./dispatch/dispatch.vue": 31314,
	"./finance/finance.vue": 17907,
	"./followUp/followUp.vue": 90611,
	"./followUp/followUpDetail.vue": 78092,
	"./grade/grade.vue": 12011,
	"./index/index.vue": 78155,
	"./invoice/invoice.vue": 85671,
	"./labor/labor.vue": 59002,
	"./labor/laborDetail.vue": 30426,
	"./login/login.vue": 86219,
	"./logs/logs.vue": 73010,
	"./menu/menu.vue": 70290,
	"./menu/menuAdd.vue": 61062,
	"./notice/notice.vue": 97994,
	"./notice/noticeAdd.vue": 14993,
	"./operate/operate.vue": 67136,
	"./operate/operateAdd.vue": 75449,
	"./platform/platform.vue": 20362,
	"./platformOperation/platformOperation.vue": 31733,
	"./platformOperation/platformOperationDetail.vue": 94008,
	"./platformWallet/platformWallet.vue": 43615,
	"./premium/premium.vue": 33185,
	"./premium/premiumAdd.vue": 313,
	"./pricing/pricing.vue": 21036,
	"./receiving/receiving.vue": 98806,
	"./recharge/recharge.vue": 67826,
	"./regulation/regulation.vue": 40726,
	"./revenue/revenue.vue": 7294,
	"./revoke/revoke.vue": 58869,
	"./rule/rule.vue": 32807,
	"./rule/ruleAdd.vue": 77880,
	"./scenarios/scenarios.vue": 83493,
	"./suggest/suggest.vue": 49135,
	"./supervision/supervision.vue": 10621,
	"./supplier/supplier.vue": 56110,
	"./supplier/supplierAdd.vue": 40099,
	"./system/system.vue": 32130,
	"./tag/tag.vue": 59338,
	"./task/Implementation.vue": 79290,
	"./task/attendance.vue": 68624,
	"./task/task.vue": 21914,
	"./task/taskDetail.vue": 65184,
	"./tax/tax.vue": 66560,
	"./template/template.vue": 34334,
	"./template/templateAdd.vue": 33183,
	"./user/user.vue": 8780,
	"./user/userDetail.vue": 89029,
	"./userChannel/userChannel.vue": 85468,
	"./version/version.vue": 12654,
	"./violation/violation.vue": 37618,
	"./wechat/wechat.vue": 76447,
	"./whiteList/whiteList.vue": 69874,
	"./workOrder/workOrder.vue": 62308,
	"./workOrder/workOrderDetail.vue": 13701,
	"./workRule/workRule.vue": 76752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4755;